import styled from "styled-components";
import { getValueFromPixelString } from "../../utils/TokenHelpers";
import { apolloSpaceInsetHalfX } from "@nexthink/apollo-tokens";
import { ROUND_BUTTON_ICON_SIZE } from "../button-icon/ButtonIcon.style";
export const KEBAB_WIDTH = ROUND_BUTTON_ICON_SIZE;
export const KEBAB_WITH_PADDING_WIDTH = KEBAB_WIDTH + getValueFromPixelString(apolloSpaceInsetHalfX);
export const StyledKebabPlaceholder = styled.div.withConfig({ displayName: "StyledKebabPlaceholder_APC-7281-productShell", componentId: "sc-18txww4" })({
    display: "inline-block",
    width: `${KEBAB_WITH_PADDING_WIDTH}px`,
});
//# sourceMappingURL=KebabWithPortal.style.js.map